import { DashboardContextAction, DashboardContextActions, DashboardTypes } from "./types"

export const setDashboardType = (type: DashboardTypes): DashboardContextAction => ({
	type: DashboardContextActions.SET_DASHBOARD_TYPE,
	payload: type,
})
